import { Typography } from '@curology/ui-components-web/react/Typography';
import React from 'react';

import Accordion from '@/components/accordion';
import { type Card } from '@/types/productSelectionAndCheckout/types';
import { getDisplayName } from '@/utils/strings/getDisplayName';

import { ModalImage } from '../ModalImage';

const activeIngredients: {
  [key: string]: string;
} = {
  minoxidil: 'Stimulates blood flow to hair and helps boost hair growth',
  finasteride: 'Supports hair growth and helps prevent hair loss',
  ketoconazole: 'Antifungal that treats dandruff and stimulates hair regrowth',
  spironolactone: 'Helps restore hair fullness and prevent future hair loss',
  caffeine: 'Stimulates the hair follicle and extends the growth phase of hair',
  melatonin: 'Helps counteract free radicals, leading to hair regrowth',
};

const nonFeaturedIngredients = 'Ethyl Alcohol, Propanediol, Purified Water';

export const HairFormulaRxModalContent = ({
  modalCard,
}: {
  modalCard: Card;
}) => {
  const { modal } = modalCard;

  return (
    <React.Fragment>
      <ModalImage modal={modal} />
      <Typography size="h2" className="cur-mb-4 cur-mt-4">
        <span dangerouslySetInnerHTML={{ __html: modal.title }} />
      </Typography>
      <Typography>
        <p>{modal.description}</p>
      </Typography>
      <Typography size="h2" className="cur-mb-4 cur-mt-4">
        Active ingredients
      </Typography>
      <div>
        {Object.keys(activeIngredients).map((ingredient, i) => {
          return (
            <Accordion
              className="cur-w-full"
              noBorder={true}
              key={i}
              caption={getDisplayName(ingredient)}
            >
              <Typography>{activeIngredients[ingredient]}</Typography>
            </Accordion>
          );
        })}
      </div>
      <Typography size="h2" className="cur-mb-4 cur-mt-4">
        Inactive ingredients
      </Typography>
      <Typography>{nonFeaturedIngredients}</Typography>
      <Typography>
        Formulas that contain minoxidil also contain lactic acid.
      </Typography>
    </React.Fragment>
  );
};
